import { Award, ShieldCheck, Clock } from 'lucide-react';
import type { PublicRating, Reliability } from '../ratings.ts';
import { RatingLine } from './RatingLine.tsx';

// Fiabilité d'un extra : l'indice n'apparaît qu'à partir d'un nombre minimal de missions (le serveur renvoie null sinon).
export function ReliabilityBadges({ reliability }: { reliability?: Reliability }) {
  if (!reliability) return null;
  const pill = { display: 'inline-flex', alignItems: 'center', gap: 4 } as const;
  const items = [
    reliability.topExtra && (
      <span key="top" className="badge badge-available" style={{ ...pill, fontWeight: 800 }} title="Au moins 10 missions réussies, excellente moyenne, aucun retard ni absence">
        <Award size={12} /> Top Extra
      </span>
    ),
    reliability.reliabilityPct !== null && (
      <span key="rel" className="badge badge-neutral" style={pill} title="Missions menées à bien sur missions engagées">
        <ShieldCheck size={12} /> Fiabilité {reliability.reliabilityPct} %
      </span>
    ),
    reliability.onTimePct !== null && reliability.honored >= 3 && (
      <span key="time" className="badge badge-neutral" style={pill} title="Part des arrivées à l'heure">
        <Clock size={12} /> {reliability.onTimePct} % à l'heure
      </span>
    ),
  ].filter(Boolean);
  if (items.length === 0) return null;
  return <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>{items}</div>;
}

// Établissement : note publique et badge « recommandé ».
export function OrgReputation({ recommended, rating }: { recommended?: boolean; rating?: PublicRating }) {
  if (!recommended && !rating) return null;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      {recommended && (
        <span className="badge badge-available" style={{ display: 'inline-flex', alignItems: 'center', gap: 4, alignSelf: 'flex-start', fontWeight: 800 }} title="Bien noté par les extras et heures validées rapidement">
          <Award size={12} /> Établissement recommandé
        </span>
      )}
      <RatingLine rating={rating} />
    </div>
  );
}
